import { render, staticRenderFns } from "./CrisisModal.vue?vue&type=template&id=687237c0&scoped=true&"
import script from "./CrisisModal.vue?vue&type=script&lang=js&"
export * from "./CrisisModal.vue?vue&type=script&lang=js&"
import style0 from "./CrisisModal.vue?vue&type=style&index=0&id=687237c0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687237c0",
  null
  
)

export default component.exports